<div class="container">
  <app-job-landing-banner
    entrypoint="find_job_banner"
    section="job"
    (shareCta)="openJobLandingDialog()"
  ></app-job-landing-banner>

  <span class="sr-only" aria-live="assertive" role="status">{{ loadingMessage }}</span>
  <div class="page-content">
    <div class="main-content">
       @if (!resumeUploaded && !showLoader) {
      <div class="resume-overlay" >
        <div class="resume-overlay-content">
          <img class="list-image" src="/assets/images/list-timeline.svg" alt="List timeline" />
          <p class="overlay-text">
            <button type="button" class="upload-text link-btn" (click)="onClickUploadResume()">Upload a resume</button> to see</p>
           <p class="overlay-text">personalized job matches</p>
        </div>
      </div>
    }
    @if (showLoader) {
      <div class="loader-wrapper" aria-hidden="true">
        <img src="/assets/animate/beaker-loader-dark.gif" alt="" />
        <p class="loading-text">Finding the latest job matches for you</p>
      </div>
    } @else {
        <app-job-list-module 
          (jobClickEmitter)="onClickJobItem($event)"
          (filterFormEmitter)="filterJobList($event)"
          (sortEmitter)="getSortedJobList($event)"
        ></app-job-list-module>
        <app-job-description-module 
          [selectedJobId]="selectedJobId"
          (jobCloseEmitter)="onClickCloseBtn()"
        ></app-job-description-module>
      }
    </div>
  </div>
</div>
